import type { BitbucketRepository } from '../../types';

export const isBitbucketRepository = (entity: any): entity is BitbucketRepository =>
	entity.__typename === 'BitbucketRepository';

export const getBitbucketRepositoryLink = (repository: BitbucketRepository): string | null =>
	repository?.href ?? null;
